/*
 * Scripts from original scraps.js that can't be ported to jQuery because they're
 * too Prototype specific. Will be included in legacy prototype sites/pages.
 */

if (window.console && console.warn) {
	console.warn('%cDEPRECATION %cThe Prototype JS library in Sitebuilder is deprecated and should not be used. Consider rewriting your script for jQuery (which is already available on the page)', 'font-weight: bold', 'font-weight: normal');
}

// Global Ajax responder used by Ajax.MultiComplete class below.
Ajax.Responders.register({
	onCreate: function(request) {
		if (request.options.multiComplete) {
			request.options.multiComplete.add(request);
		}
	},
	onComplete: function(request) {
		if (request.options.multiComplete) {
			request.options.multiComplete.done(request);
		}
	}
});

/* Track a collection of AJAX requests, triggering callbacks when
 * all are complete.
 *
 * onComplete will always fire. Then onSuccess will fire if ALL were
 * successful, otherwise onFailure will fire.
 *
 *  c = new Ajax.MultiCompleter({onComplete: function(){ alert("tada") }};
 *  new Ajax.Request(url, { multiComplete : c });
 *  new Ajax.Request(url2, { multiComplete : c });
 *  new Ajax.Request(url3, { multiComplete : c });
 *  c.finishedAdding(); //necessary otherwise it will never fire.
 *  // "tada" will be shown only when all three are complete.
 */
Ajax.MultiCompleter = function(opts) {
	var n = Prototype.emptyFunction;
	this.onComplete = opts.onComplete || n;
	this.onSuccess = opts.onSuccess || n;
	this.onFailure = opts.onFailure || n;
	this.onLoading = opts.onLoading || n;
	this.reset();
	this.loaded = false;
	this.loading = false;
}
Ajax.MultiCompleter.prototype = {
	add	: function(r) {
		this.tasks.push(r);
		if (!this.loading) this.onLoading();
	},
	done : function(r) {
		this.numberFinished++;
		if (this.allAdded) {
			this._checkFinished();
		}
	},
	finishedAdding : function() {
		this.allAdded = true;
		this._checkFinished();
	},
	_checkFinished : function() {
		if (this.numberFinished >= this.tasks.length) {
			this.loaded = true;
			this.loading = false;
			this.onComplete();
			var failed = false;
			$A(this.tasks).each(function(t) {
				if (t.transport.status < 200 || t.transport.status >= 300) {
					failed = true;
					throw $break;
				}
			})
			if (failed) {
				this.onFailure();
			} else {
				this.onSuccess();
			}
			this.reset();
		}
	},
	reset : function() {
		this.tasks = [];
		this.numberFinished = 0;
		this.allAdded = false;
		this.fired = false;
	},
	onComplete : function() {},
	onSuccess : function() {},
	onFailure : function() {}
};



//Track AJAX requests so we can cancel 'old' ones.
Ajax.currentRequests = {};
Ajax.Responders.register({
	onCreate: function(request) {
		if (request.options.onlyLatestOfClass && Ajax.currentRequests[request.options.onlyLatestOfClass]) {
			// if a request of this class is already in progress, attempt to abort it before launching this new request
			try {
				Ajax.currentRequests[request.options.onlyLatestOfClass].transport.abort();
			} catch(e) {}
		}
		// keep note of this request object so we can cancel it if superceded
		Ajax.currentRequests[request.options.onlyLatestOfClass] = request;
	},
	onComplete: function(request) {
		if (request.options.onlyLatestOfClass) {
			// remove the request from our cache once completed so it can be garbage collected
			Ajax.currentRequests[request.options.onlyLatestOfClass] = null;
		}
	}
});

Ajax.Responders.register({
	onException: function(r, e) {
		if (window.console) console.error(e);
	}
});
